// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_j8-1";
export var rowFirst = "_j8-3";
export var rowLast = "_j8-5";
export var rowMiddle = "_j8-4";
export var ticketListScroll = "_j8-2";
export var ticketStack = "_j8-0";